import "../../../styles/productView.scss";
import "../../../styles/productViewListItem.scss";

import { CustomerListHeader, CustomerListItem } from "./CustomerListItem.jsx";
import Icon, { iconTypes } from "../../common/components/Icon.jsx";
import Loading, { loadingTypes } from "../../common/components/Loading";
import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";

class CustomerList extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            width: null,
        };
        this.containerNode = null;

        this.prepareItems = this.prepareItems.bind(this);
        this.onClickPrintLabels = this.onClickPrintLabels.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
    }

    prepareItems() {
        const {
            customers,
            localization,
            setModal,
            updateNoOfDollies,
            selectCustomer,
            loading,
            treated,
        } = this.props;

        const retNodes = [];

        for (let i = 0; i < customers.length; i++) {
            retNodes[retNodes.length] = (
                <CustomerListItem
                    key={i}
                    localization={localization}
                    customer={customers[i]}
                    setModal={setModal}
                    updateNoOfDollies={updateNoOfDollies}
                    selectCustomer={selectCustomer}
                    treated={treated}
                />);
        }
        if( loading ) {
            retNodes[retNodes.length] = (
                <Loading key={"view-list-loading"} height={48} type={loadingTypes.line} />
            );
        }

        return retNodes;
    }

    
    onClickPrintLabels() {
        const {
            createAddressLabels,
            treated
        } = this.props;
        createAddressLabels(treated);
    }

    onRefresh() {
        const {
            getOrdersForDoughProducts,
        } = this.props;
        getOrdersForDoughProducts();
    }

    render() {
        const {
            localization,
            height,
            treated,
            creating,
            loading,
            customers,
            normalCratesAlias,
            mediumCratesAlias,
            smallCratesAlias,
        } = this.props;

        const nodes = this.prepareItems();

        const canSubmit = !creating && customers.some(p => p.noOfDollies > 0 && p.selected);

        return (
            <React.Fragment>
                <div style={{overflowX: "auto", overflowY: "hidden", height: height-210}}>
                    <div className={"hub-product-view-header-wrapper"} >
                        <CustomerListHeader localization={localization} normalCratesAlias={normalCratesAlias} mediumCratesAlias={mediumCratesAlias} smallCratesAlias={smallCratesAlias} treated={treated}/>
                    </div>
                    <div className={"hub-product-view-items-wrapper"} style={{overflowY: "auto", height: height-245}}>
                        {nodes}
                    </div>
                </div>    
                
                <div style={{padding:"right"}}>
                    <div className="buttons">
                        <button className="btn"  disabled={!canSubmit} onClick={this.onClickPrintLabels} style={{ width: "200px" }}>
                            <Icon type={iconTypes.print} />{localization.text("dominos", "production", treated ? "printAgain": "printLabels")}
                        </button>
                        { !treated && (
                            <button className="btn" disabled={loading} onClick={this.onRefresh} style={{ width: "200px" }}>
                                <Icon type={iconTypes.change} />{localization.text("dominos", "production", "refresh")}
                            </button>
                        )}
                    </div>
                </div>
            </React.Fragment>);
    }
}

CustomerList.propTypes = {
    height: PropTypes.number,
    width: PropTypes.number,
    // If true a loading icon will be displayed
    isLoading: PropTypes.bool,
    customers: PropTypes.array.isRequired,
    localization: Localization.propTypes.isRequired,
    setModal: PropTypes.func.isRequired,
    style: PropTypes.object,
    createAddressLabels: PropTypes.func.isRequired,
    updateNoOfDollies: PropTypes.func.isRequired,
    treated: PropTypes.bool.isRequired,
    creating: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    selectCustomer: PropTypes.func.isRequired,
    normalCratesAlias: PropTypes.string,
    mediumCratesAlias: PropTypes.string,
    smallCratesAlias: PropTypes.string,
    getOrdersForDoughProducts : PropTypes.func,
};

export default CustomerList;
